"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpreadingGun = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const DefinitionAndHelpers_1 = require("../../DefinitionAndHelpers");
const EffluentTracker_1 = require("../Effluent/EffluentTracker");
const PivotEffluentSpreader_1 = require("./PivotEffluentSpreader");
const TravellingEffluentSpreader_1 = require("./TravellingEffluentSpreader");
const typeName = 'SpreadingGun';
const dev = process.env.REACT_APP_DEBUG;
const debug = dev && false;
// export type SpreadingGunProps = {
//   throwDistance?: number
//   location?: Position
//   path?: TimedPosition[]
//   spreading?: boolean
//   flow?: number
// }
class SpreadingGun extends EffluentTracker_1.EffluentTracker {
    constructor(ob) {
        var _a, _b;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
        this.spreadingGunParent = (_b = ob.spreadingGunParent) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Updated relevant runs. Allows runs of type SpreadingGun
     * @param runList
     * @returns runs of correct run type
     */
    getRelevantRuns(runList) {
        debug && console.log('Using SpreadingGun specific - getRelevantRuns');
        // let allowed = [EFFLUENT_PATH_TYPE.LateralEffluentSpreader, EFFLUENT_PATH_TYPE.PivotEffluentSpreader]
        let allowed = [DefinitionAndHelpers_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader];
        let filteredRuns = runList.filter((run) => {
            const parsed = run.pathType;
            let found = Object.values(DefinitionAndHelpers_1.EFFLUENT_PATH_TYPE).includes(parsed);
            if (found) {
                return allowed.includes(parsed);
            }
            return false;
        });
        return filteredRuns;
    }
    createSpreadingEventAndDeadZone(areas, runs, manual = false) {
        if (this.spreadingGunParent) {
            let eff = this;
            switch (this.spreadingGunParent) {
                // case 'LateralEffluentSpreader':
                //   eff = new LateralEffluentSpreader({ ...this })
                //   break
                case 'PivotEffluentSpreader':
                    eff = new PivotEffluentSpreader_1.PivotEffluentSpreader({ ...this });
                    break;
            }
            console.log('Pivot Run', this.spreadingGunParent);
            return eff.createSpreadingEventAndDeadZone(areas, runs, manual);
        }
        return super.createSpreadingEventAndDeadZone(areas, runs, manual);
    }
    getBestMatchedRun(runs, rawPath = this.path) {
        debug && console.log('Using default - getBestMatchedRun');
        const parsedPath = rawPath !== null && rawPath !== void 0 ? rawPath : this.path;
        // check there are runs to check against
        // check the path is of length
        if (runs.length === 0 || parsedPath === null || parsedPath.length === 0) {
            return undefined;
        }
        // sort runs by type
        // const lateralRuns = runs.filter((val) => val.pathType === EFFLUENT_PATH_TYPE.LateralEffluentSpreader)
        const pivotsRuns = runs.filter((val) => val.pathType === DefinitionAndHelpers_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader);
        // construct a spreader for each
        // const latSpreader = new LateralEffluentSpreader({ ...this })
        const pivSpreader = new PivotEffluentSpreader_1.PivotEffluentSpreader({ ...this });
        // const bestLat = latSpreader.getBestMatchedRun(lateralRuns, path)
        const bestPiv = pivSpreader.getBestMatchedRun(pivotsRuns, parsedPath);
        const options = [bestPiv].filter((val) => val !== undefined).sort((a, b) => a.distance - b.distance);
        if (options.length === 0) {
            return undefined;
        }
        else {
            return options[0];
        }
    }
    /**
     * Manually Updates
     * - filteredPath (getExpectedRun -> filterOutPathOutliers)
     * - runDifference (getExpectedRun)
     * - mappedRun (this)
     * - mappedPath (this)
     * - last irrigated (this)
     * @param runs
     * @param lastTimestamp
     */
    updateMappedRun(runs, lastTimestamp) {
        // create a lateral & effluent version.
        let bestMatched = this.getBestMatchedRun(runs);
        if (bestMatched) {
            let eff;
            switch (bestMatched.run.pathType) {
                // case EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
                //   eff = new LateralEffluentSpreader(this)
                //   break
                case DefinitionAndHelpers_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
                    eff = new PivotEffluentSpreader_1.PivotEffluentSpreader(this);
                    this.spreadingGunParent = 'PivotEffluentSpreader';
                    break;
                default:
                    eff = new TravellingEffluentSpreader_1.TravellingEffluentSpreader(this);
                    this.spreadingGunParent = 'TravellingEffluentSpreader';
                    break;
            }
            eff.updateMappedRun(runs, lastTimestamp);
            this.filteredPath = eff.filteredPath;
            this.runDifference = eff.runDifference;
            this.mappedRun = eff.mappedRun;
            this.mappedPath = eff.mappedPath;
            this.lastIrrigated = lastTimestamp;
            // this.spreadingGunParent = eff.type
        }
        else {
            super.updateMappedRun(runs, lastTimestamp);
        }
    }
    /**
     * Function to get the spread LatLngs, and area (m^2), of all 3 conditions
     */
    getSpreadOfAllRuns(relevantRun) {
        let effluentSpreader = this;
        if (relevantRun) {
            switch (relevantRun.pathType) {
                // case EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
                //   effluentSpreader = new LateralEffluentSpreader(this)
                //   break
                case DefinitionAndHelpers_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
                    effluentSpreader = new PivotEffluentSpreader_1.PivotEffluentSpreader(this);
                    break;
            }
            return effluentSpreader.getSpreadOfAllRuns(relevantRun);
        }
        // spread for raw
        let raw = this.getSpreadOfRawRun(relevantRun);
        // spread for filtered
        let filtered = this.getSpreadOfFilteredRun(relevantRun);
        // spread for mapped
        let mapped = relevantRun ? this.getSpreadOfMappedRun(relevantRun) : undefined;
        return { raw, filtered, mapped };
    }
    /**
     * Function to get the spread LatLngs, and area (m^2), of the raw run
     * @returns LatLngs and area (m^2) obj
     */
    getSpreadOfRawRun(relevantRun, path) {
        let effluentSpreader = this;
        if (relevantRun) {
            switch (relevantRun.pathType) {
                // case EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
                //   effluentSpreader = new LateralEffluentSpreader(this)
                //   break
                case DefinitionAndHelpers_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
                    effluentSpreader = new PivotEffluentSpreader_1.PivotEffluentSpreader(this);
                    break;
            }
            return effluentSpreader.getSpreadOfRawRun(relevantRun, path);
        }
        return super.getSpreadOfRawRun(relevantRun);
    }
    /**
     * Function to get the spread LatLngs, and area (m^2), of the filtered run
     * @returns LatLngs and area (m^2) obj
     */
    getSpreadOfFilteredRun(relevantRun, path) {
        let effluentSpreader = this;
        if (relevantRun) {
            switch (relevantRun.pathType) {
                // case EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
                //   effluentSpreader = new LateralEffluentSpreader(this)
                //   break
                case DefinitionAndHelpers_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
                    effluentSpreader = new PivotEffluentSpreader_1.PivotEffluentSpreader(this);
                    break;
            }
            return effluentSpreader.getSpreadOfFilteredRun(relevantRun, path);
        }
        return super.getSpreadOfFilteredRun();
    }
    getSpreadOfMappedRun(relevantRun, rawPath = this.path) {
        let effluentSpreader = this;
        const parsedPath = rawPath !== null && rawPath !== void 0 ? rawPath : this.path;
        if (relevantRun) {
            switch (relevantRun.pathType) {
                // case EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
                //   effluentSpreader = new LateralEffluentSpreader(this)
                //   break
                case DefinitionAndHelpers_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
                    effluentSpreader = new PivotEffluentSpreader_1.PivotEffluentSpreader(this);
                    break;
            }
            return effluentSpreader.getSpreadOfMappedRun(relevantRun, parsedPath);
        }
        return super.getSpreadOfMappedRun(relevantRun, parsedPath);
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of dam',
                required: true,
            },
            purpose: {
                type: 'String',
                editable: true,
                label: 'Purpose',
                name: 'purpose',
                description: 'Used for',
            },
            throwDistance: {
                type: 'Number',
                editable: true,
                label: 'Throw Radius (m)',
                name: 'throwDistance',
                description: 'Throw distance of effluent spreader',
                required: true,
            },
            flow: {
                type: 'Number',
                editable: true,
                label: 'Effluent Flow (L/min)',
                name: 'flow',
                description: 'The rate of liquid L/m',
                required: true,
            },
            location: {
                type: 'RelatedType',
                editable: false,
                label: 'Location',
                name: 'Location',
                description: 'Last position of the effluent spreader',
                objectTypeId: 'Location',
                direction: iotv_v3_types_1.PathDirection.child,
                edgeTypeId: 'EffluentTracker_has_Location',
            },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.SpreadingGun = SpreadingGun;
